import { useMutation } from "@tanstack/react-query";
import { useBookingInvalidate } from "PFCore/hooks/queries";
import { ActivitiesCollection } from "PFCore/hooks/queries/activities/query_keys";
import { useActivitiesInvalidate } from "PFCore/hooks/queries/activities/use_activities_invalidate";
import { useBookingsForUpdateInvalidate } from "PFCore/hooks/queries/bookings/bulk_operation/use_bookings_for_update_invalidate";
import { useEngagementsInvalidate } from "PFCore/hooks/queries/engagements/use_engagements_invalidate";
import { useProfileInvalidate } from "PFCore/hooks/queries/profile";
import { useRolesInvalidate } from "PFCore/hooks/queries/roles/use_roles_invalidate";
import { deleteOwner } from "PFCore/services/owners";
import { MutationOptions } from "PFTypes/request_options";

import { useActivityInvalidate } from "../activity/use_activity_invalidate";

export const useOwnerDelete = (
  activityId: number,
  { onSuccess, ...options }: MutationOptions<number> = {}
) => {
  const { invalidate: invalidateActivity } = useActivityInvalidate();
  const { invalidateByCollection: invalidateActvitiesByCollection } = useActivitiesInvalidate();
  const { invalidateRoles } = useRolesInvalidate();
  const { invalidateAll: invalidateEngagements } = useEngagementsInvalidate();
  const { invalidate: invalidateForUpdate } = useBookingsForUpdateInvalidate();
  const { invalidateAllProfiles } = useProfileInvalidate();
  const { invalidate: invalidateBookings } = useBookingInvalidate();

  return useMutation({
    mutationFn: (id: number) => deleteOwner(id),
    onSuccess: (...params) => {
      invalidateActivity([activityId]);
      invalidateActvitiesByCollection(ActivitiesCollection.All);
      invalidateRoles();
      invalidateEngagements();
      invalidateForUpdate();
      invalidateAllProfiles();
      invalidateBookings();
      onSuccess?.(...params);
    },
    ...options
  });
};
